
import { Fragment, h } from 'preact';
import { Price } from '@searchspring/snap-preact-components';

function formatPrice(value, symbol, decimalPlaces) {
	return `${symbol}${Number(value).toFixed(decimalPlaces)}`;
}

export function Prices ({ priceRange, core, subProps, pricingType }) {
	let decimalPlaces = 0;
	let corePrice = String(core.price);
	let msrpPrice = String(core.msrp);
	const currencySymbol = window.Resources.shopCurrencySymbol;

	if (corePrice.includes('.') || msrpPrice.includes('.')) {
		decimalPlaces = 2;
	}

	const normalizedPricingType = pricingType ? String(pricingType).toLowerCase().trim() : null;

	if (priceRange) {
		let priceRange1 = String(priceRange[1]);
		let priceRange2 = String(priceRange[0]);

		if (priceRange1.includes('.') || priceRange2.includes('.')) {
			decimalPlaces = 2;
		}

		// priceRange[1] = min price, priceRange[0] = max price
		if (normalizedPricingType === 'from') {
			return (
				<span class="ss__price ss__price--from">
					{`From ${formatPrice(priceRange[1], currencySymbol, decimalPlaces)}`}
				</span>
			);
		}

		if (normalizedPricingType === 'range') {
			return (
				<span class="ss__price ss__price--range">
					{`${formatPrice(priceRange[1], currencySymbol, decimalPlaces)}-${formatPrice(priceRange[0], currencySymbol, decimalPlaces)}`}
				</span>
			);
		}

		return (
			<>
				<Price symbol={currencySymbol} {...subProps.price} value={Number(priceRange[1])} decimalPlaces={decimalPlaces} />
				<span class="em-dash">&#8211;</span>
				<Price symbol={currencySymbol} {...subProps.price} value={Number(priceRange[0])} decimalPlaces={decimalPlaces} />
			</>
		);
	}

	// No price range — use core price
	if (normalizedPricingType === 'from') {
		return (
			<span class="ss__price ss__price--from">
				{`From ${formatPrice(core.price, currencySymbol, decimalPlaces)}`}
			</span>
		);
	}

	//otherwise, return core price
	return (
		<>
			{core.price < core.msrp ? (
				<>
					<Price symbol={currencySymbol} {...subProps.price} value={core.msrp} lineThrough={true} decimalPlaces={decimalPlaces} />
					&nbsp;
					<Price symbol={currencySymbol} {...subProps.price} value={core.price} decimalPlaces={decimalPlaces} />
				</>
			) : (
				<Price symbol={currencySymbol} {...subProps.price} value={core.price} decimalPlaces={decimalPlaces} />
			)}
		</>
	);
}
